import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';

const StyledBox = styled(Box)(() => ({
  '&.observerContainer': {
    overflow: 'hidden',
  },
}));

const LazyLoad = (props) => {
  const moreRef = useRef(null);
  const observerRef = useRef(null);
  const {
    children, skeleton, dataLoaded, threshold = 0.1,
  } = props;
  const { isCrawler } = useSelector((state) => state.globalData);
  const isLazyLoadEnabled = () => {
    if (isCrawler) return true;
    if (typeof window === 'undefined') return false;
    return !('IntersectionObserver' in window);
  };

  const [showChildren, setShowChildren] = useState(isLazyLoadEnabled());

  // Show children immediately if data is loaded and we're coming from back navigation
  // This helps scroll restoration work correctly
  useEffect(() => {
    if (dataLoaded && typeof window !== 'undefined' && !showChildren) {
      // Check if we're likely coming from back navigation (scroll position > 0)
      // Show content immediately to help scroll restoration
      if (window.scrollY > 0) {
        setShowChildren(true);
      } else if (moreRef.current) {
        // Also check if element is near viewport (within 2 viewport heights)
        const rect = moreRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight * 2) {
          setShowChildren(true);
        }
      }
    }
  }, [dataLoaded, showChildren]);

  const scrollCallBack = (entries) => {
    if (
      (entries[0].intersectionRatio > 0 || entries[0].isIntersecting)
      && dataLoaded
    ) {
      setShowChildren(true);
    }
  };
  useEffect(() => {
    if ('IntersectionObserver' in window && !showChildren) {
      observerRef.current = new IntersectionObserver(scrollCallBack, {
        rootMargin: '0px',
        threshold,
      });
      moreRef.current && observerRef.current.observe(moreRef.current);
    }
    return () => {
      if (observerRef.current && moreRef.current) {
        observerRef.current.unobserve(moreRef.current);
        observerRef.current.disconnect();
      }
    };
  }, [showChildren, dataLoaded]);

  if (!showChildren) {
    return (
      <StyledBox ref={moreRef} className="observerContainer">
        {skeleton}
      </StyledBox>
    );
  }
  return children;
};
export { LazyLoad };
